import React from "react";
import { Navbar } from "../components/protected-navbar/Navbar";
import { Sidebar } from "../components/protected-sidebar/Sidebar";

const ProtectedLayout = ({ children }) => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Navbar />
      <Sidebar />
      <div className="p-4 sm:ml-64">
        <div className="p-4 mt-14">{children}</div>
      </div>
    </div>
  );
};

export default ProtectedLayout;
